import head from "lodash/head"
import get from "lodash/get"
import commonApiAuthRequest from "../apiAuthRequest"
import { TOIR_PLANNING_SERVICE_URL } from "./constants"

const ordersFetch = eventId =>
  commonApiAuthRequest({
    url: `${TOIR_PLANNING_SERVICE_URL}/orders`,
    params: { query: `eventId==${eventId}` },
  })

/**
 * makes request to get sap issue id by eventId
 *
 * @param {number} eventId
 * @return {Array.<Object>} response - sapIssueId
 */
export const getSapIssueIdByEvent = async eventId => {
  if (!eventId) {
    return undefined
  }

  const { data: ordersList } = await ordersFetch(eventId)

  return get(head(ordersList), `orderId`)
}
